import React from 'react'
import classNames from 'classnames'

type PaginationProps = {
  currentPage: number
  totalPages: number
  onPaginationPageClick: (page: number) => void
}

const Pagination: React.FC<PaginationProps> = ({ currentPage, totalPages, onPaginationPageClick }) => {
  const windowSize = 4

  const handlePageClick = (e: React.MouseEvent<HTMLAnchorElement>, page: number) => {
    e.preventDefault()
    onPaginationPageClick(page)
  }
  /*
  const firstPage = currentPage > 1 && (
    <span className="first">
      <a 
        href="#" 
        rel="first" 
        aria-label="Go to first page"
        onClick={(e) => handlePageClick(e, 1)}
      >
        &laquo; First
      </a>
    </span>
  )
*/

  const previousPage = currentPage > 1 && (
    <span className="prev">
      <a href="#" rel="prev" aria-label="Go to previous page" onClick={e => handlePageClick(e, currentPage - 1)}>
        &lsaquo; Prev
      </a>
    </span>
  )

  const nextPage = currentPage < totalPages && (
    <span className="next">
      <a href="#" rel="next" aria-label="Go to next page" onClick={e => handlePageClick(e, currentPage + 1)}>
        Next &rsaquo;
      </a>
    </span>
  )
  /*
  const lastPage = currentPage !== totalPages && (
    <span className="last">
      <a 
        href="#" 
        rel="last" 
        aria-label={`Go to last page (${totalPages})`}
        onClick={(e) => handlePageClick(e, totalPages)}
      >
        Last &raquo;
      </a>
    </span>
  )
*/
  const leftEllipsis = currentPage > windowSize + 1 && (
    <span className="page gap" aria-hidden="true">
      &hellip;
    </span>
  )

  const rightEllipsis = currentPage + windowSize < totalPages && (
    <span className="page gap" aria-hidden="true">
      &hellip;
    </span>
  )

  const pageWindow: number[] = []
  for (let i = currentPage - windowSize; i < currentPage; i++) {
    if (i >= 1) pageWindow.push(i)
  }
  pageWindow.push(currentPage)
  for (let i = currentPage + 1; i <= currentPage + windowSize && i <= totalPages; i++) {
    pageWindow.push(i)
  }

  const currentWindow = pageWindow.map(page => {
    const isCurrent = currentPage === page
    return (
      <span className={classNames('page', { current: isCurrent })} key={`page-${page}`}>
        {isCurrent ? (
          <span aria-current="page">{page}</span>
        ) : (
          <a href="#" aria-label={`Go to page ${page}`} onClick={e => handlePageClick(e, page)}>
            {page}
          </a>
        )}{' '}
      </span>
    )
  })

  return (
    <nav className="pagination" aria-label="Pagination">
      {previousPage} {leftEllipsis} {currentWindow} {rightEllipsis} {nextPage}
    </nav>
  )
}

export default Pagination
